import { BoxProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { ApiBulkExport, useBulkExportRasters, useRasterTypeDescriptions } from "@nens/ldo/api-v1";
import { removeNullUndefined } from "@nens/shared-utils";

import { RastersMap } from "../rasters-map/rasters-map";

interface BulkExportRastersMapProps extends BoxProps {
  bulkExport: ApiBulkExport;
  mapId: string;
  size: "s" | "l";
  extraButtons?: ReactNode[];
}

export function BulkExportRastersMap({
  bulkExport,
  mapId,
  children,
  ...rest
}: BulkExportRastersMapProps) {
  const rasterResponses = useBulkExportRasters(bulkExport);
  const rasterDescriptions = useRasterTypeDescriptions();

  const rasters = removeNullUndefined(
    rasterResponses.map((rasterResponse) =>
      rasterResponse.isSuccess
        ? {
            rasterType: rasterResponse.data.type,
            raster: rasterResponse.data.raster,
            description: rasterDescriptions[rasterResponse.data.type] ?? "Unknown",
          }
        : null
    )
  );

  return (
    <RastersMap
      rasters={rasters}
      wmsLayers={bulkExport.wms_layers}
      markers={[]}
      mapId={mapId}
      {...rest}
    >
      {children}
    </RastersMap>
  );
}
